/**
 * External Imports
 */
import { FC } from 'react';

/**
 * Style Imports
 */
import {
  Card,
  CardContainer,
  CardHeader,
  CardSubHeader,
  CardHeaderContainer,
  CardContent,
  CardContentContainer,
  ChevronRightIcon,
  StatusIconCompleted,
  StatusContainer,
  StatusIconOpened,
  CardHeaderRight
} from './PastTasksCard.styles';

interface PastTasksCardProps {
  taskId: string;
  subtype: string;
  taskDate: string;
  taskTitle: string;
  taskDescription: string;
  completed: boolean;
  facility: string;
}
const PastTasksCard: FC<PastTasksCardProps> = ({
  taskId,
  subtype,
  taskDate,
  taskTitle,
  taskDescription,
  completed,
  facility
}) => {
  return (
    <Card id={`Task-Card-${taskId}`} className="ms-2 me-3">
      <CardContainer>
        <CardHeaderContainer>
          <CardHeader>{subtype}</CardHeader>
          <CardHeaderRight>{taskDate}</CardHeaderRight>
        </CardHeaderContainer>
        <CardSubHeader>{taskTitle}</CardSubHeader>
        <CardContent>{facility}</CardContent>
        <CardContentContainer>
          <CardContent>{taskDescription}</CardContent>
          <StatusContainer>
            {completed ? (
              <>
                <StatusIconCompleted>check_circle</StatusIconCompleted>
                <CardContent>Completed</CardContent>
              </>
            ) : (
              <>
                <StatusIconOpened>check_circle</StatusIconOpened>
                <CardContent>Opened</CardContent>
              </>
            )}
          </StatusContainer>
        </CardContentContainer>
      </CardContainer>
      <ChevronRightIcon>chevron_right</ChevronRightIcon>
    </Card>
  );
};

// export default AddIssueFromPatientRound;
export default PastTasksCard;
